var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "testqs",
      staticStyle: {
        position: "absolute",
        top: "10px",
        left: "10px",
        right: "10px",
        bottom: "10px"
      }
    },
    [
      _c(
        "a",
        {
          staticClass: "close",
          attrs: { href: "" },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.$emit("close2")
            }
          }
        },
        [_vm._v("×")]
      ),
      _vm._v(" "),
      _vm.current == _vm.group.questions.length && _vm.passed
        ? _c("div", { staticClass: "done passed" }, [
            _c("p", [_vm._v("Congratulations! You have passed this test.")])
          ])
        : _vm.current == _vm.group.questions.length
        ? _c("div", { staticClass: "done not-passed" }, [_vm._m(0)])
        : _vm.current == -1
        ? _c("div", { class: { "password-prompt": _vm.passwordUsed } }, [
            _vm.passwordUsed
              ? _c("p", { staticClass: "error" }, [
                  _vm._v("You have already taken this test.")
                ])
              : _vm._e()
          ])
        : _c("div", { staticClass: "qs" }, [
            _c("h1", [
              _vm._v(
                _vm._s(
                  _vm.item.parent ? _vm.item.parent.subtitle : _vm.item.subtitle
                ) +
                  " " +
                  _vm._s(_vm.item.title)
              )
            ]),
            _vm._v(" "),
            _c("h2", [_vm._v("Please answer these questions:")]),
            _vm._v(" "),
            _c("h3", [
              _vm._v(
                "Question " +
                  _vm._s(_vm.current + 1) +
                  " of " +
                  _vm._s(_vm.group && _vm.group.questions.length)
              )
            ]),
            _vm._v(" "),
            _vm.question
              ? _c("div", { staticClass: "question" }, [
                  _c("h4", [_vm._v(_vm._s(_vm.question.text))]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "answers" },
                    _vm._l(_vm.question.answers, function(answer, ai) {
                      return _c("li", [
                        _c("label", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.answers,
                                expression: "answers"
                              }
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              value: ai,
                              checked: Array.isArray(_vm.answers)
                                ? _vm._i(_vm.answers, ai) > -1
                                : _vm.answers
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.answers,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = ai,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 && (_vm.answers = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.answers = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.answers = $$c
                                }
                              }
                            }
                          }),
                          _vm._v(
                            "\n            " +
                              _vm._s(answer.text) +
                              "\n          "
                          )
                        ])
                      ])
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _vm.isAnswered === true
                    ? _c("div", { staticClass: "answered correct" }, [
                        _vm._v("\n        You answered correctly.\n      ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isAnswered === false
                    ? _c("div", { staticClass: "answered incorrect" }, [
                        _vm._v(
                          "\n        You did not answer correctly.\n      "
                        )
                      ])
                    : _vm._e()
                ])
              : _vm._e()
          ]),
      _vm._v(" "),
      _vm.current == -1
        ? _c("div", {}, [
            _c("p", [
              _vm._v(
                'If you are ready to take your test or homework now, press START. Be aware that once you pressed "start" you will need to fully complete it to validate your completion.'
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.current == -1
        ? _c("div", { staticClass: "actions" }, [
            _c(
              "button",
              {
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.checkPassword($event)
                  }
                }
              },
              [_vm._v("Start")]
            )
          ])
        : _vm.current < _vm.group.questions.length
        ? _c("div", { staticClass: "actions" }, [
            _vm.question && _vm.isAnswered === null
              ? _c(
                  "button",
                  {
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.next($event)
                      }
                    }
                  },
                  [_vm._v("Submit")]
                )
              : _vm.question && _vm.current <= _vm.group.questions.length - 1
              ? _c(
                  "button",
                  {
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.next($event)
                      }
                    }
                  },
                  [_vm._v("Next")]
                )
              : _vm.question
              ? _c(
                  "button",
                  {
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.next($event)
                      }
                    }
                  },
                  [_vm._v("Finish")]
                )
              : _vm._e()
          ])
        : _c("div", { staticClass: "actions" }, [
            _c(
              "button",
              {
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.doClose($event)
                  }
                }
              },
              [_vm._v("Close")]
            )
          ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "Unfortunately, you have not passed this test. You will need to try again. Please contact "
      ),
      _c(
        "a",
        {
          staticStyle: {
            "font-weight": "bold",
            "text-decoration": "underline",
            color: "#1c49ed"
          },
          attrs: { href: "mailto:bodytech@me.com?cc=ivamazzoleni@hotmail.com" }
        },
        [_vm._v("support")]
      ),
      _vm._v(" to be granted access once more.")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }